import React from 'react'
import { MdCall, MdEmail, MdWhatsapp } from "react-icons/md";

import { HashLink } from 'react-router-hash-link'
export default function Footer() {
  return (
      <div className="flex flex-col">
    <div id='contactus' className='bg-white-500 text-black w-full lg:w-auto flex flex-col gap-[3em] lg:gap-[0em] lg:flex-row h-full lg:h-[20em] py-[5em] justify-evenly'>

        <div className='hidden ml-[3em] mt-[1em] w-1/3'>
          <p className="font-[Satoshi] text-xl  font-extrabold uppercase ">Renthub</p>
          <p className="font-[Satoshi] text-xl ">The project is building a platform where we manage rent for landlords - To make paying rent easier for tenants and reduce pressure.</p>
        </div>

        <div className='pl-[5em] -mt-[1em] flex flex-col gap-[.5em] lg:w-1/3'>
          <p className="font-[Satoshi] text-base lg:text-xl uppercase font-bold ">About Us</p>
          <HashLink to='/#services' className="font-[Satoshi] text-base lg:text-xl  my-[1em] font-normal capitalize ">Our services</HashLink>
          <HashLink to='/#hero' className="font-[Satoshi] -mt-[1em] text-base lg:text-xl  my-[1em] font-normal capitalize ">Our Features</HashLink>

        </div>
        
        <div className='pl-[5em] -mt-[1em] flex flex-col gap-[.5em] lg:w-1/3'>
          <p className="font-[Satoshi] text-base lg:text-xl uppercase font-bold ">Services</p>
          <HashLink to='/#services' className="font-[Satoshi] text-base lg:text-xl  my-[1em] font-normal capitalize ">Account Management</HashLink>
          <HashLink to='/#hero' className="font-[Satoshi] -mt-[1em] text-base lg:text-xl  my-[1em] font-normal capitalize ">Rent savings</HashLink>
          <HashLink to='/#hero' className="font-[Satoshi] -mt-[1em] text-base lg:text-xl  my-[1em] font-normal capitalize ">Real Time Update</HashLink>
          <HashLink to='/#hero' className="font-[Satoshi] -mt-[1em] text-base lg:text-xl  my-[1em] font-normal capitalize ">Track Income</HashLink>

        </div>

        <div className='ml-[4em] lg:ml-[3em] flex flex-col lg:w-1/3'>
          <p className="font-[Satoshi] text-base lg:text-xl  font-bold uppercase ">Contact Us</p>
       
         <div className="phone_no flex gap-[1em] mt-[1em] "> 
          <MdCall className='text-2xl '/>
          <p className=''>+2347039673550</p>
           </div>   

         <div className="phone_no flex gap-[1em] mt-[1em] "> 
          <MdWhatsapp className='text-2xl '/>
          <p className=''>+2349160237577</p>
           </div>   

         <div className="phone_no flex gap-[1em] mt-[1em] "> 
          <MdEmail className='text-2xl '/>
          <p className=''>admin@rivmevservices.com.ng</p>
           </div>   
        </div>
    </div>

     <p className='text-center mb-[4em]'> © 2025 RIVMEV SERVICES LIMITED. All Rights Reserved</p>
      </div>
  )
}
